import { Avatar, Card, TableCell, TableRow } from "@mui/material";
import DataHandlerTable from "src/components/data-handler/table";
import Map from "src/components/map";
import PaginationButtons from "src/components/pagination";
import useAchievers from "../hooks/useAchievers";
import DataFilter from "./filter";
import useFilter from "../hooks/use-filter";

const headers = [
  "financial.payout.admin.request.table.no",
  "global.profile",
  // "financial.payout.admin.request.table.user_name",
  "financial.payout.admin.request.table.full_name",
  "search.Rank",
];

const RankAchieversUsers = () => {
  const methods = useFilter();
  const filter = methods.watch();
  const onFilter = methods.handleSubmit((inputData) => {
    fetchData(1, inputData);
  });
  const { state, fetchData, rowStart, ...rest } = useAchievers(filter);
  const { data, ...dataProps } = state;

  return (
    <>
      <Card sx={{ pt: 1 }}>
        <DataFilter onFilter={onFilter} methods={methods} />
        <DataHandlerTable
          name="category-table"
          dataProps={{ ...dataProps }}
          headers={headers}
        >
          <Map
            list={data}
            render={(item, i) => (
              <TableRow key={item.id}>
                <TableCell>{i + rowStart}</TableCell>
                <TableCell>
                  {item?.user_profile?.profile_image ? (
                    <Avatar
                      alt={item?.username}
                      src={item?.user_profile?.profile_image}
                      sx={{ width: 24, height: 24 }}
                    />
                  ) : (
                    <Avatar sx={{ width: 24, height: 24 }}>
                      {item?.username.slice(0, 1)}
                    </Avatar>
                  )}
                </TableCell>
                {/* <TableCell>{item?.username}</TableCell> */}
                <TableCell>{item?.original_name}</TableCell>
                <TableCell>{item?.rank?.rank_name}</TableCell>
              </TableRow>
            )}
          />
        </DataHandlerTable>
      </Card>
      <PaginationButtons {...rest} />
    </>
  );
};

export default RankAchieversUsers;
